import { SvgIcon, SvgIconProps } from "@mui/material";

const SolidBgIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<path
				d="M10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C14.1417 2.5 17.5 5.485 17.5 9.16667C17.5 10.05 17.105 10.8983 16.4017 11.5233C15.6983 12.1483 14.7442 12.5 13.75 12.5H11.6667C11.2949 12.494 10.9318 12.6125 10.6351 12.8367C10.3384 13.0608 10.1252 13.3777 10.0294 13.737C9.93362 14.0963 9.9607 14.4773 10.1064 14.8194C10.252 15.1615 10.5079 15.4451 10.8333 15.625C10.9997 15.7785 11.1138 15.9803 11.1596 16.2021C11.2054 16.4238 11.1806 16.6543 11.0886 16.8612C10.9967 17.068 10.8422 17.2409 10.647 17.3555C10.4517 17.4701 10.2255 17.5206 10 17.5Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M7.08333 9.58333C7.54357 9.58333 7.91667 9.21024 7.91667 8.75C7.91667 8.28976 7.54357 7.91667 7.08333 7.91667C6.6231 7.91667 6.25 8.28976 6.25 8.75C6.25 9.21024 6.6231 9.58333 7.08333 9.58333Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M10.4167 7.08333C10.8769 7.08333 11.25 6.71024 11.25 6.25C11.25 5.78976 10.8769 5.41667 10.4167 5.41667C9.95643 5.41667 9.58333 5.78976 9.58333 6.25C9.58333 6.71024 9.95643 7.08333 10.4167 7.08333Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M13.75 9.58333C14.2102 9.58333 14.5833 9.21024 14.5833 8.75C14.5833 8.28976 14.2102 7.91667 13.75 7.91667C13.2898 7.91667 12.9167 8.28976 12.9167 8.75C12.9167 9.21024 13.2898 9.58333 13.75 9.58333Z"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};

export default SolidBgIcon;
